import React from 'react';
import { render } from 'react-dom';
import ReactSVG from 'react-svg';
import SvgTest from './SvgTest.js';
import SvgVerticalRink from './SvgVerticalRink.js';
import axios from 'axios';
import { apiServerUrl } from '../config';
import './WizardTable.css';
import * as d3Hex from 'd3-hexbin';
import * as d3 from 'd3';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import { authHeader, requestOptions, jwtTeam } from '../_helpers';

export class ShotChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shotType: 'SHOT'
    };
  }
  //static propTypes = {...}
  componentWillMount() {}
  handleChange(e) {
    let currentComponent = this;
    const { name, value } = e.target;
    //currentComponent.calculateData();
    currentComponent.drawCircles(value);
  }
  // calculateData() {
  //   let currentComponent = this;
  //   let dataset = this.state.dataset;
  //   // //GOAL // // SHOT // FACEOFF // MISSED SHOT // SHOT BLOCKED //
  //   //TAKEAWAY // HIT // GIVEAWAY // PENALTY
  //   console.log(this.state.shotType);
  //   if (this.state.shotType == "") {
  //     currentComponent.setState(prevState => ({ cleanedDataset: dataset }));
  //   } else {
  //     let cleanedData = dataset.filter(
  //       datapoint => datapoint.event_type == this.state.shotType
  //     );
  //     console.log("about to set state" + JSON.stringify(cleanedData));
  //     currentComponent.setState(prevState => ({ cleanedDataset: cleanedData }));
  //   }
  // }
  drawCircles(value) {
    if (!value) {
      value = this.state.shotType;
    }
    let currentComponent = this;
    let dataset = this.state.dataset;
    let cleanedData = dataset.filter(
      datapoint => datapoint.event_type == value
    );
    console.log('in draw , val is' + value);
    console.log('in draw , cleanedData is' + JSON.stringify(cleanedData));
    let h = 86;
    let w = 200;
    var svg = d3.select('svg');
    //svg.selectAll("circle").remove()
    svg.selectAll('circle.hockey_event').remove();
    svg
      .selectAll('circlec')
      .data(cleanedData)
      .enter()
      .append('circle')
      .attr('class', function(d) {
        return 'hockey_event';
      })
      .attr('cx', function(d) {
        return (parseInt(d.xcoord) + w / 2) * 1.73022;
      })
      .attr('cy', function(d) {
        return (parseInt(d.ycoord) + h / 2) * 1.708697674;
      })
      .attr('r', 1);
  }
  componentDidMount() {
    let currentComponent = this;
    axios
      .get(
        apiServerUrl +
          '/event_locations' +
          '?player_id=' +
          //"462" +
          this.props.player_id +
          '&season=20182019' +
          '&season_type=02',
        requestOptions()
      )
      .then(function(response) {
        currentComponent.setState(prevState => ({ dataset: response.data }));
        currentComponent.drawCircles();

        // .on("mouseover", function(d) {
        //   var xPosition = parseFloat(d3.select(this).attr("cx"));
        //   var yPosition = parseFloat(d3.select(this).attr("cy"));
        //
        //   //Update the tooltip position and value
        //   d3.select("#tooltip")
        //     .style("left", xPosition + "px")
        //     .style("top", yPosition + "px")
        //     .select("#eventType")
        //     .text(d.event_type);
        //   d3.select("#tooltip")
        //     .select("#player")
        //     .text(d.p1name);
        //   d3.select("#tooltip")
        //     .select("#period")
        //     .text(d.period);
        //   d3.select("#tooltip")
        //     .select("#strength")
        //     .text(function() {
        //       if (d.strength == "701") {
        //         return "Even";
        //       } else if (d.strength == "702") {
        //         return "Powerplay";
        //       } else if (d.strength == "703") {
        //         return "Shorthanded";
        //       }
        //     });
        //   //Show the tooltip
        //   d3.select("#tooltip").classed("hidden", false);
        // })
        // .on("mouseout", function() {
        //   //Hide the tooltip
        //   d3.select("#tooltip").classed("hidden", true);
        // });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  shouldComponentUpdate() {
    // Prevents component re-rendering
    return false;
  }

  _setRef(componentNode) {
    this._rootNode = componentNode;
  }

  render() {
    return (
      <div>
        <div className="line-container" ref={this._setRef.bind(this)} />
        <div
          onChange={e => this.handleChange(e)}
          style={{
            display: 'flex',
            paddingBottom: '1em',
            backgroundColor: 'white'
          }}
        >
          {/*<div className="radioButton">
            <label>ALL</label>
            <input type="radio" name="handed" value="" />
          </div>*/}
          <div className="radioButton">
            <label>GOALS</label>
            <input type="radio" name="handed" value="GOAL" />
          </div>
          <div className="radioButton">
            <label>SHOT</label>
            <input type="radio" name="handed" value="SHOT" />
          </div>{' '}
          <div className="radioButton">
            <label>FACEOFF</label>
            <input type="radio" name="handed" value="FACEOFF" />
          </div>{' '}
          <div className="radioButton">
            <label>MISSED SHOT</label>
            <input type="radio" name="handed" value="MISSED SHOT" />
          </div>{' '}
          <div className="radioButton">
            <label>SHOT BLOCKED</label>
            <input type="radio" name="handed" value="SHOT BLOCKED" />
          </div>{' '}
          <div className="radioButton">
            <label>TAKEAWAY</label>
            <input type="radio" name="handed" value="TAKEAWAY" />
          </div>{' '}
          <div className="radioButton">
            <label>HIT</label>
            <input type="radio" name="handed" value="HIT" />
          </div>{' '}
          <div className="radioButton">
            <label>GIVEAWAY</label>
            <input type="radio" name="handed" value="GIVEAWAY" />
          </div>
          <div className="radioButton">
            <label>PENALTY</label>
            <input type="radio" name="handed" value="PENALTY" />
          </div>
        </div>

        <SvgTest style={{ backgroundColor: 'white' }} h={86} w={200} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/ShotChart.js